// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".question-analysis{font-size:1.875rem;display:flex;justify-content:flex-start;color:#495561}.question-analysis .analysis-title{margin-left:.625rem;width:5rem}.question-analysis .analysis-content{width:calc(100% - 5rem);margin-left:1rem}", ""]);
// Exports
module.exports = exports;
